import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "finished-setup" }
const _hoisted_2 = { class: "finished-setup__saddle" }
const _hoisted_3 = { key: 0 }
const _hoisted_4 = { key: 1 }
const _hoisted_5 = { class: "finished-setup__row" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "finished-setup__row" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = { key: 1 }
const _hoisted_11 = { class: "finished-setup__row" }
const _hoisted_12 = { key: 0 }
const _hoisted_13 = { key: 1 }
const _hoisted_14 = { class: "finished-setup__row" }
const _hoisted_15 = { key: 0 }
const _hoisted_16 = { key: 1 }
const _hoisted_17 = { class: "finished-setup__row" }
const _hoisted_18 = { class: "finished-setup__handlebar" }
const _hoisted_19 = { key: 0 }
const _hoisted_20 = { key: 1 }
const _hoisted_21 = { class: "finished-setup__row" }
const _hoisted_22 = { key: 0 }
const _hoisted_23 = { key: 1 }
const _hoisted_24 = { class: "finished-setup__row" }
const _hoisted_25 = { key: 0 }
const _hoisted_26 = { key: 1 }
const _hoisted_27 = { class: "finished-setup__row" }
const _hoisted_28 = { key: 0 }
const _hoisted_29 = { key: 1 }
const _hoisted_30 = { class: "finished-setup__row" }
const _hoisted_31 = { key: 0 }
const _hoisted_32 = { key: 1 }
const _hoisted_33 = { class: "finished-setup__row" }
const _hoisted_34 = { key: 0 }
const _hoisted_35 = { key: 1 }
const _hoisted_36 = { class: "finished-setup__row" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { key: 1 }
const _hoisted_39 = { class: "finished-setup__row" }
const _hoisted_40 = { key: 0 }
const _hoisted_41 = { key: 1 }
const _hoisted_42 = { class: "finished-setup__crankset" }
const _hoisted_43 = { class: "finished-setup__row" }
const _hoisted_44 = { key: 0 }
const _hoisted_45 = { key: 1 }
const _hoisted_46 = { class: "finished-setup__pedals" }
const _hoisted_47 = { key: 0 }
const _hoisted_48 = { class: "finished-setup__row" }
const _hoisted_49 = { key: 0 }
const _hoisted_50 = { key: 1 }
const _hoisted_51 = { class: "finished-setup__bike-setup" }
const _hoisted_52 = { class: "finished-setup__small" }
const _hoisted_53 = { class: "finished-setup__row" }
const _hoisted_54 = { key: 0 }
const _hoisted_55 = { key: 1 }
const _hoisted_56 = { class: "finished-setup__row" }
const _hoisted_57 = { key: 0 }
const _hoisted_58 = { key: 1 }
const _hoisted_59 = { class: "finished-setup__row" }
const _hoisted_60 = { key: 0 }
const _hoisted_61 = { key: 1 }

import { storeToRefs } from 'pinia'
import { useBikeStore } from '@/store/bikeStore'
import { useMeasurementStore } from '@/store/measurementStore'
import { useI18n } from 'vue-i18n'


export default /*@__PURE__*/_defineComponent({
  __name: 'FinishedSetup',
  setup(__props) {

const { t } = useI18n()
const bikeStore = useBikeStore()
const measurementStore = useMeasurementStore()

const { bikeFinalSetup } = storeToRefs(bikeStore)
const { finalMeasurement } = storeToRefs(measurementStore)

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("h3", null, _toDisplayString(_unref(t)('common.bike.saddle')), 1),
      (
          _unref(finalMeasurement).saddle.active.SADDLE_BRAND ||
          _unref(finalMeasurement).saddle.active.SADDLE_MODEL
        )
        ? (_openBlock(), _createElementBlock("span", _hoisted_3, _toDisplayString(`${_unref(finalMeasurement).saddle.active.SADDLE_BRAND} ${_unref(finalMeasurement).saddle.active.SADDLE_MODEL}`), 1))
        : (_openBlock(), _createElementBlock("span", _hoisted_4, "-")),
      _createElementVNode("h4", null, _toDisplayString(_unref(t)('common.position.index')), 1),
      _createElementVNode("div", _hoisted_5, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('common.position.x')), 1),
        (_unref(finalMeasurement).saddle.x)
          ? (_openBlock(), _createElementBlock("span", _hoisted_6, _toDisplayString(`${_unref(finalMeasurement).saddle.x} ${_unref(t)('common.unit.mm')}`), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_7, "-"))
      ]),
      _createElementVNode("div", _hoisted_8, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('common.position.y')), 1),
        (_unref(finalMeasurement).saddle.y)
          ? (_openBlock(), _createElementBlock("span", _hoisted_9, _toDisplayString(`${_unref(finalMeasurement).saddle.y} ${_unref(t)('common.unit.mm')}`), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_10, "-"))
      ]),
      _createElementVNode("h4", null, _toDisplayString(_unref(t)('common.specs')), 1),
      _createElementVNode("div", _hoisted_11, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('common.size.width')), 1),
        (_unref(finalMeasurement).saddle.active.SADDLE_WIDTH)
          ? (_openBlock(), _createElementBlock("span", _hoisted_12, _toDisplayString(`${_unref(finalMeasurement).saddle.active.SADDLE_WIDTH} ${_unref(t)('common.unit.mm')}`), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_13, "-"))
      ]),
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('measurement.saddle.shape.index')), 1),
        (_unref(finalMeasurement).saddle.active.SHAPE)
          ? (_openBlock(), _createElementBlock("span", _hoisted_15, _toDisplayString(_unref(finalMeasurement).saddle.active.SHAPE), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_16, "-"))
      ]),
      _createElementVNode("div", _hoisted_17, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('measurement.saddle.anatomical')), 1),
        _createElementVNode("span", null, _toDisplayString(_unref(finalMeasurement).saddle.active.ANATOMIC_DESIGN
            ? _unref(t)('common.yes')
            : _unref(t)('common.no')), 1)
      ])
    ]),
    _createElementVNode("div", _hoisted_18, [
      _createElementVNode("h3", null, _toDisplayString(_unref(t)('common.bike.handlebar')), 1),
      (
          _unref(finalMeasurement).handlebar.active.HANDLEBAR_BRAND ||
          _unref(finalMeasurement).handlebar.active.HANDLEBAR_MODEL
        )
        ? (_openBlock(), _createElementBlock("span", _hoisted_19, _toDisplayString(`${_unref(finalMeasurement).handlebar.active.HANDLEBAR_BRAND} ${_unref(finalMeasurement).handlebar.active.HANDLEBAR_MODEL}`), 1))
        : (_openBlock(), _createElementBlock("span", _hoisted_20, "-")),
      _createElementVNode("h4", null, _toDisplayString(_unref(t)('common.position.index')), 1),
      _createElementVNode("div", _hoisted_21, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('common.position.x')), 1),
        (_unref(finalMeasurement).handlebar.x)
          ? (_openBlock(), _createElementBlock("span", _hoisted_22, _toDisplayString(`${_unref(finalMeasurement).handlebar.x * -1} ${_unref(t)('common.unit.mm')}`), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_23, "-"))
      ]),
      _createElementVNode("div", _hoisted_24, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('common.position.y')), 1),
        (_unref(finalMeasurement).handlebar.y)
          ? (_openBlock(), _createElementBlock("span", _hoisted_25, _toDisplayString(`${_unref(finalMeasurement).handlebar.y} ${_unref(t)('common.unit.mm')}`), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_26, "-"))
      ]),
      _createElementVNode("h4", null, _toDisplayString(_unref(t)('common.specs')), 1),
      _createElementVNode("div", _hoisted_27, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('common.size.width')), 1),
        (_unref(finalMeasurement).handlebar.active.HANDLEBAR_WIDTH)
          ? (_openBlock(), _createElementBlock("span", _hoisted_28, _toDisplayString(`${_unref(finalMeasurement).handlebar.active.HANDLEBAR_WIDTH} ${_unref(t)('common.unit.mm')}`), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_29, "-"))
      ]),
      _createElementVNode("div", _hoisted_30, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('measurement.handlebar.reach')), 1),
        (_unref(finalMeasurement).handlebar.active.HANDLEBAR_REACH)
          ? (_openBlock(), _createElementBlock("span", _hoisted_31, _toDisplayString(`${_unref(finalMeasurement).handlebar.active.HANDLEBAR_REACH} ${_unref(t)('common.unit.mm')}`), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_32, "-"))
      ]),
      _createElementVNode("div", _hoisted_33, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('measurement.handlebar.drop')), 1),
        (_unref(finalMeasurement).handlebar.active.HANDLEBAR_DROP)
          ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(`${_unref(finalMeasurement).handlebar.active.HANDLEBAR_DROP} ${_unref(t)('common.unit.mm')}`), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_35, "-"))
      ]),
      _createElementVNode("div", _hoisted_36, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('measurement.handlebar.sweep')), 1),
        (_unref(finalMeasurement).handlebar.active.BACK_SWEEP_ANGLE)
          ? (_openBlock(), _createElementBlock("span", _hoisted_37, _toDisplayString(`${_unref(finalMeasurement).handlebar.active.BACK_SWEEP_ANGLE} ${_unref(t)('common.unit.degreesSign')}`), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_38, "-"))
      ]),
      _createElementVNode("div", _hoisted_39, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('measurement.handlebar.flare')), 1),
        (_unref(finalMeasurement).handlebar.active.FLARE_ANGLE)
          ? (_openBlock(), _createElementBlock("span", _hoisted_40, _toDisplayString(`${_unref(finalMeasurement).handlebar.active.FLARE_ANGLE} ${_unref(t)('common.unit.degreesSign')}`), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_41, "-"))
      ])
    ]),
    _createElementVNode("div", _hoisted_42, [
      _createElementVNode("h3", null, _toDisplayString(_unref(t)('common.bike.crankset')), 1),
      _createElementVNode("h4", null, _toDisplayString(_unref(t)('common.specs')), 1),
      _createElementVNode("div", _hoisted_43, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('common.bike.crankLength')), 1),
        (_unref(finalMeasurement)?.crankset.active)
          ? (_openBlock(), _createElementBlock("span", _hoisted_44, _toDisplayString(`${_unref(finalMeasurement)?.crankset.active} ${_unref(t)('common.unit.mm')}`), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_45, "-"))
      ])
    ]),
    _createElementVNode("div", _hoisted_46, [
      _createElementVNode("h3", null, _toDisplayString(_unref(t)('common.bike.pedals')), 1),
      (
          _unref(finalMeasurement).pedal.active.PEDAL_BRAND ||
          _unref(finalMeasurement).pedal.active.PEDAL_MODEL
        )
        ? (_openBlock(), _createElementBlock("span", _hoisted_47, _toDisplayString(`${_unref(finalMeasurement).pedal.active.PEDAL_BRAND} ${_unref(finalMeasurement).pedal.active.PEDAL_MODEL}`), 1))
        : _createCommentVNode("", true),
      _createElementVNode("h4", null, _toDisplayString(_unref(t)('common.specs')), 1),
      _createElementVNode("div", _hoisted_48, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('common.size.height')), 1),
        (_unref(finalMeasurement)?.pedal.active.PEDAL_HEIGHT)
          ? (_openBlock(), _createElementBlock("span", _hoisted_49, _toDisplayString(`${_unref(finalMeasurement)?.pedal.active.PEDAL_HEIGHT} ${_unref(t)('common.unit.mm')}`), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_50, "-"))
      ])
    ]),
    _createElementVNode("div", _hoisted_51, [
      _createElementVNode("h3", null, _toDisplayString(_unref(t)('common.bike.setup')), 1),
      _createElementVNode("h4", null, _toDisplayString(_unref(t)('common.distances')), 1),
      _createElementVNode("div", _hoisted_52, _toDisplayString(_unref(t)('measurement.tapeMeasure')), 1),
      _createElementVNode("div", _hoisted_53, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('common.bike.saddleHeight')), 1),
        (_unref(bikeFinalSetup)?.SADDLE_HEIGHT)
          ? (_openBlock(), _createElementBlock("span", _hoisted_54, _toDisplayString(`${_unref(bikeFinalSetup)?.SADDLE_HEIGHT} ${_unref(t)('common.unit.mm')}`), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_55, "-"))
      ]),
      _createElementVNode("div", _hoisted_56, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('common.bike.saddleHandlebar')), 1),
        (_unref(bikeFinalSetup)?.SADDLE_HANDLEBAR_DISTANCE)
          ? (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString(`${_unref(bikeFinalSetup)?.SADDLE_HANDLEBAR_DISTANCE} ${_unref(t)('common.unit.mm')}`), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_58, "-"))
      ]),
      _createElementVNode("div", _hoisted_59, [
        _createElementVNode("span", null, _toDisplayString(_unref(t)('common.bike.saddleHandlebarDrop')), 1),
        (_unref(bikeFinalSetup)?.setupResult?.HandlebarDrop)
          ? (_openBlock(), _createElementBlock("span", _hoisted_60, _toDisplayString(`${_unref(bikeFinalSetup)?.setupResult?.HandlebarDrop} ${_unref(t)('common.unit.mm')}`), 1))
          : (_openBlock(), _createElementBlock("span", _hoisted_61, "-"))
      ])
    ])
  ]))
}
}

})